/**
 * The Box Score Club brand mark.
 *
 * Renders the actual Logo #1 asset (transparent PNG of the
 * shield/home-plate mark with internal scoreboard grid, red vertical
 * indicator, and red stitch chevrons). Served from
 * /brand/logo-mark-transparent.png so the art matches the brand file
 * pixel-for-pixel rather than an SVG approximation.
 *
 * ``size`` sets both width and height in pixels. The underlying image is
 * 1024x1024 so it stays crisp down to 18px (favicon) and up to 200px+
 * (hero surfaces).
 */
export function HomePlateLogo({
  size = 36,
  className = "",
  title = "The Box Score Club",
}) {
  return (
    <img
      src="/brand/logo-mark-transparent.png"
      alt={title}
      width={size}
      height={size}
      draggable="false"
      className={`shrink-0 select-none block ${className}`}
      style={{ width: size, height: size }}
      data-testid="home-plate-logo"
    />
  );
}
